import { useRouter } from 'next/router'

import type { FeatureFromURL } from '../utils/feature'
import { featureFromParams } from '../utils/feature'

export * from '../utils/feature'

/**
 * Returns true if the feature is enabled for the current router.
 */
export const useFeatureFromURL = (feature: FeatureFromURL) => {
    const router = useRouter()
    if (!router) return false
    return featureFromParams(feature, router)
}
